import { jsx, jsxs } from "react/jsx-runtime";
import { Suspense, useCallback, useEffect, useMemo, useState } from "react";
import { Flex } from "antd";
import TeamsApi from "./../../api/TeamsApi.js";
import Loader from "./../../components/loader/Loader.js";
import HeaderTabs from "./../../components/tabComponents/HeaderTabs.js";
import TabsTabItems from "./../../components/tabComponents/TabsTabItems.js";
import { withScrollToTop } from "./../../hoc";
import useTabItems from "./../../hook/useTabItems.js";
import { useParams } from "react-router-dom";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import { Components } from "./teamContent/teamContentService";
import TeamHeader from "./teamHeader/TeamHeader";
import "./teamDetails.css";
const TeamDetails = () => {
  const getTeamDetailsApi = TeamsApi.getTeamDetails();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [teamDetails, setTeamDetails] = useState(null);
  const tabItems = useMemo(() => {
    var _a;
    return (_a = teamDetails == null ? void 0 : teamDetails.tabItems) != null ? _a : [];
  }, [teamDetails]);
  const {
    items,
    activeTabKey,
    activeTabData,
    tabsActiveTabId,
    setActiveTabKey,
    setTabsActiveTabId
  } = useTabItems({ tabItems });
  const Component = useMemo(
    () => {
      var _a;
      return (_a = Components[activeTabKey]) != null ? _a : Loader;
    },
    [activeTabKey]
  );
  useEffect(() => {
    getTeamDetails(id);
    return () => {
      getTeamDetailsApi.cancel();
    };
  }, [id]);
  const getTeamDetails = async (id2) => {
    setLoading(true);
    try {
      const response = await getTeamDetailsApi.call(id2);
      setTeamDetails(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const videoClickCallback = useCallback(() => {
    track(EVENT_ACTIONS.VIDEO_FROM_TEAM);
  }, []);
  return loading && !teamDetails ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsxs(
    Flex,
    {
      vertical: true,
      gap: 24,
      style: { position: "relative" },
      className: "team-details",
      children: [
        loading && /* @__PURE__ */ jsx(Loader, { overlay: true }),
        /* @__PURE__ */ jsx(
          TeamHeader,
          {
            imageUrl: teamDetails == null ? void 0 : teamDetails.imageUrl,
            name: teamDetails.name,
            founded: teamDetails.founded,
            country: teamDetails.country,
            venue: teamDetails.venue,
            isFavorite: teamDetails.isFavorite,
            itemId: teamDetails.id,
            children: /* @__PURE__ */ jsx(
              HeaderTabs,
              {
                items,
                activeTabKey,
                setActiveTabKey
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(Flex, { vertical: true, gap: 16, children: [
          /* @__PURE__ */ jsx(
            TabsTabItems,
            {
              activeTabData,
              tabItemId: tabsActiveTabId,
              setTabsActiveTabId,
              radioStyleType: "secondary"
            }
          ),
          /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Loader, {}), children: /* @__PURE__ */ jsx(
            Component,
            {
              data: activeTabData,
              tabItemId: tabsActiveTabId,
              teamId: id,
              videoClickCallback
            }
          ) })
        ] })
      ]
    }
  );
};
var stdin_default = withScrollToTop(TeamDetails);
export {
  stdin_default as default
};
